'use client';

import React, { useState, useEffect } from 'react';
import Image from 'next/image';
export default function LoadingSpinner() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  // Prevent hydration mismatch by not rendering on server
  if (!mounted) {
    return (
      <div className="fixed inset-0 bg-white dark:bg-gray-900 z-50">
        <div className="flex flex-col items-center justify-center min-h-screen">
          <div className="relative w-20 h-20 mb-8">
            <Image
              src="/img/ava_icon.png"
              alt="AIVA Logo"
              width={64}
              height={64}
              className="w-full h-full object-contain"
              style={{
                filter: 'drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1))'
              }}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 bg-white dark:bg-gray-900 backdrop-blur-sm z-50">
      <div className="flex flex-col items-center justify-center min-h-screen">
        <div className="relative animate-fadeIn">
          <div className="relative w-20 h-20 mb-8">
            <Image
              src="/img/ava_icon.png"
              alt="AIVA Logo"
              width={64}
              height={64}
              className="w-full h-full object-contain"
              style={{
                filter: 'drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1))'
              }}
            />
          </div>

          <div className="flex space-x-2 justify-center">
            <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '0s' }} />
            <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }} />
            <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '0.4s' }} />
          </div>
        </div>
      </div>
    </div>
  );
}